import { getApiUrl } from '../../../Url';
import AnchorAPIError from '../../AnchorAPIError';

type ImportStatusParameters = {
  stationId: string;
};

type Item = {
  rssImportItemId: number;
  state: 'waiting' | 'started' | 'finished' | 'failed';
  kind: 'item' | 'channel';
  title: string;
};

type ImportStatusResponse = {
  state: 'processing' | 'complete';
  percentageComplete: number;
  items: Item[];
};

const getEndpointUrl = (stationId: string) =>
  getApiUrl({ path: `stations/webStationId:${stationId}/importStatus` });

export const fetchImportStatus = async ({
  stationId,
}: ImportStatusParameters): Promise<ImportStatusResponse> => {
  const url = getEndpointUrl(stationId);
  const response = await fetch(url, {
    credentials: 'same-origin',
  });

  if (response.ok) {
    return response.json();
  }

  const { status, type } = response;
  throw new AnchorAPIError(
    response,
    `Non-200 response status: ${status} (${type})`
  );
};
